import script from "./CourseCertificateView.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseCertificateView.vue?vue&type=script&setup=true&lang=js"

import "./CourseCertificateView.vue?vue&type=style&index=0&id=6ccc3722&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ccc3722"]])

export default __exports__